import * as React from 'react';
import './eventDescription.module.scss';
import { MarkdownText } from '../../../../../mainv2/containers/common/text/MarkdownText';
import { EventShowView } from '../../../../types/events';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { BrushedLabel } from '../../../atoms/layout/BrushedLabel';

type Props = {
  event: EventShowView;
};
export const EventDescription = observer(
  class EventDescription extends React.Component<Props> {
    render() {
      const { event } = this.props;
      return (
        <div>
          <div styleName="header-sub">
            <MarkdownText source={event.introduction} />
          </div>
          {GlobalStatesV3.viewport.isDesktop && <div styleName="title">こんな方におすすめ</div>}
          {GlobalStatesV3.viewport.isMobile && <BrushedLabel styleName="title">こんな方におすすめ</BrushedLabel>}
          <div styleName="matching-people">
            <MarkdownText source={event.target_description} />
          </div>
        </div>
      );
    }
  }
);
